export default () => ({
  preferences: null,
})
